import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useState, useEffect } from 'react';
import { Card, Dropdown, ListGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MessageThread } from './MessageThread';
import { getConversations } from 'redux/chatSlice';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';

const MessagesDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [isAllSeenPreviewMessages, setIsAllSeenPreviewMessages] =
    useState(false);
  const [countUnreadMessagesNotPreviewed, setCountUnreadMessagesNotPreviewed] =
    useState(0);

  const { conversations } = useSelector(state => state.chat);
  const { currentUser: userLogged, socket } = useSelector(state => state.login);
  const branchOffices = useSelector(state => state.branchOffice.branchOffices);

  const lastTenConversations = conversations.slice(0, 10);

  useEffect(() => {
    userLogged?.id && dispatch(getBranchOfficesByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    if (branchOffices.length === 0) return;
    const branchOfficesIds = branchOffices.map(branchOffice => branchOffice.id);

    dispatch(getConversations(branchOfficesIds));
  }, [branchOffices]);

  useEffect(() => {
    if (socket && branchOffices.length) {
      socket.removeAllListeners('message');
      socket.on('message', () => {
        if (branchOffices.length === 0) return;
        const branchOfficesIds = branchOffices.map(
          branchOffice => branchOffice.id
        );
        dispatch(getConversations(branchOfficesIds));
      });
    }
  }, [socket, branchOffices]);

  useEffect(() => {
    hasUnreadPreviewMessages();
    const count = conversations
      .slice(10)
      .filter(
        conversation =>
          conversation.lastMessage?.client && !conversation.lastMessage?.read_at
      ).length;
    setCountUnreadMessagesNotPreviewed(count);
  }, [conversations]);

  const hasUnreadPreviewMessages = () => {
    setIsAllSeenPreviewMessages(
      conversations.every(conversation => {
        if (!conversation.lastMessage?.client) {
          // Si el mensaje no tiene cliente, es enviado por el administrador y se considera leído.
          return true;
        }
        // Si el mensaje tiene cliente, se verifica si está leído o no.
        return !!conversation.lastMessage?.read_at;
      })
    );
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Dropdown navbar={true} as="li" show={isOpen} onToggle={handleToggle}>
      <Dropdown.Toggle
        variant="link"
        className={classNames('nav-link text-600 btn-reveal p-0 mr-3', {
          'notification-indicator notification-indicator-primary':
            !isAllSeenPreviewMessages
        })}
        bsPrefix="my-dropdown-toggle"
        style={{ boxShadow: 'none', border: 'none' }}
      >
        <FontAwesomeIcon icon="inbox" transform="shrink-6" className="fs-4" />
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="dropdown-menu-card dropdown-menu-card-messages dropdown-menu-end dropdown-caret-bg bg-white"
        style={{ boxShadow: 'rgba(0, 0, 0, 0.5) 0.5px 0.5px 2px 0px' }}
      >
        <Card
          className="dropdown-menu-notification dropdown-menu-end shadow-none"
          style={{ maxWidth: '20rem' }}
        >
          <FalconCardHeader
            className="card-header"
            title="Mensajes"
            titleTag="h6"
            light={false}
          />
          {!lastTenConversations?.length ? (
            <Card.Body className="text-center">
              <FontAwesomeIcon icon="message" className="text-1000 fs-3" />
              <p className="text-1000 fw-bold fs-1">No hay mensajes nuevos</p>
            </Card.Body>
          ) : (
            <ListGroup
              variant="flush"
              className="fw-normal fs--1 scrollbar"
              style={{ maxHeight: '19rem' }}
            >
              {lastTenConversations.map(message => (
                <MessageThread thread={message} key={message.id} />
              ))}
            </ListGroup>
          )}
          <Card.Footer className="text-center border-top">
            <a
              className="card-link d-block"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/mensajes');
              }}
            >
              Ver todos los mensajes
              {!!countUnreadMessagesNotPreviewed && (
                <span
                  className="badge bg-warning ms-2"
                  style={{ verticalAlign: 'middle' }}
                >
                  {countUnreadMessagesNotPreviewed}
                </span>
              )}
            </a>
          </Card.Footer>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MessagesDropdown;

{
  /*
                <ListGroup.Item
                  key={index}
                  className={classNames(
                    'border-x-0 border-300 border-bottom-0',
                    {
                      'bg-200': !message.lastMessage.read_at
                    }
                  )}
                >
                  <Card.Body style={{ padding: '0.5rem' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <Image
                        src={message.client.photo}
                        roundedCircle
                        style={{ width: '50px', marginRight: '10px' }}
                      />
                      <div>
                        <strong style={{ fontSize: '0.8rem' }}>
                          {message.client.firstName} {message.client.lastName}
                        </strong>{' '}
                        -{' '}
                        <span style={{ fontSize: '0.7rem' }}>
                          {new Date(
                            message.lastMessage.created_at
                          ).toLocaleTimeString()}
                        </span>
                        <br />
                        <small className="text-muted">
                          {message.lastMessage.message}
                        </small>
                      </div>
                      {!message.lastMessage.read_at && (
                        <Badge pill bg="primary" className="ms-auto">
                          Nuevo
                        </Badge>
                      )}
                    </div>
                  </Card.Body>
                      </ListGroup.Item>*/
}
